var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationhub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 40,
    height: 40,
    transform: "translate(123 163)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-123 -163)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-notifications-outline",
    "data-name": "Icon ion-notifications-outline",
    d: "M16.6,30.27a4.815,4.815,0,0,1-4.809-4.809v-.239H6.858a2.122,2.122,0,0,1-1.95-1.193,1.982,1.982,0,0,1,.263-2.12c.1-.128.207-.252.307-.373A8.467,8.467,0,0,0,7.127,18.97a14.873,14.873,0,0,0,.638-5.037,9.42,9.42,0,0,1,1.7-5.851A8.011,8.011,0,0,1,12.9,5.562a.371.371,0,0,0,.182-.169,4.4,4.4,0,0,1,1.23-2.006,3.323,3.323,0,0,1,4.572,0,4.422,4.422,0,0,1,1.233,2.006.386.386,0,0,0,.182.17,8.007,8.007,0,0,1,3.44,2.521,9.419,9.419,0,0,1,1.7,5.85,14.861,14.861,0,0,0,.635,5.037,8.459,8.459,0,0,0,1.649,2.565c.1.121.2.245.307.373h0a1.984,1.984,0,0,1,.26,2.122,2.114,2.114,0,0,1-1.941,1.191H21.411v.239A4.815,4.815,0,0,1,16.6,30.27Zm-3.269-5.049v.239a3.269,3.269,0,0,0,6.537,0v-.239ZM16.6,4.016a2.262,2.262,0,0,0-2.037,1.809A1.869,1.869,0,0,1,13.49,6.987a6.433,6.433,0,0,0-2.8,2.03,7.939,7.939,0,0,0-1.382,4.916,16.032,16.032,0,0,1-.735,5.575,9.929,9.929,0,0,1-1.906,3.009c-.1.119-.2.24-.3.366a.444.444,0,0,0-.063.485.574.574,0,0,0,.558.313H26.352a.567.567,0,0,0,.55-.311.446.446,0,0,0-.061-.487c-.1-.125-.2-.246-.3-.365a9.921,9.921,0,0,1-1.906-3.009,16.019,16.019,0,0,1-.732-5.574,7.937,7.937,0,0,0-1.383-4.914,6.429,6.429,0,0,0-2.8-2.032,1.9,1.9,0,0,1-1.073-1.159A2.309,2.309,0,0,0,16.6,4.016Z",
    transform: "translate(126.286 166.863)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationhub);
export default __webpack_public_path__ + "static/media/notificationhub.c1c08fe882d462a8c4fb247055bda53c.svg";
export { ForwardRef as ReactComponent };